import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import classnames from 'classnames';
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

export class BootstrapModal extends Component {
  constructor (props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal (event) {
    event.stopPropagation();
    if (this.props.onClose) {
      return this.props.onClose(event);
    }
    return this.props.toggleModal('');
  }

  render () {
    const {
      banner = {},
      addCloseIcon = true,
      title,
      header,
      footer,
      body,
      bannerClass = '',
      bannerOverrideClasses = '',
      titleClass = '',
      headerClass = '',
      subheaderClass = '',
      bodyClass = '',
      footerClass = '',
      modalClass = '',
      modalSize = 'sm-size',
      showModal,
      subheader,
      goBack,
      fixedHeaderFooter = false,
      fixedTitleFooter = false,
      stickyFooter = false
    } = this.props;
    const bannerTypeClass = get(banner, 'type', '');
    const bannerChildClass = get(banner, 'childClass', '');
    const bannerClassName = classnames('modal-banner text-center', bannerClass, bannerTypeClass);
    const bannerOverrideClassName = classnames(bannerOverrideClasses)
    const dialogClassName = classnames('BootstrapModal modal-dialogue', modalSize, modalClass);
    const titleClassName = classnames('flex space-between middle', titleClass, {
      'border-bottom modal-fixed-header-footer': fixedTitleFooter
    });
    const headerClassName = classnames('modal-header', headerClass, {
      'text-center': !fixedHeaderFooter,
      'text-left border-bottom modal-fixed-header-footer': fixedHeaderFooter
    });
    const bodyClassName = classnames('modal-body', bodyClass, {
      'modal-fixed-header-footer': fixedHeaderFooter
    });
    const footerClassName = classnames('modal-footer', (stickyFooter && 'modal-sticky-footer'), footerClass, {
      'modal-fixed-header-footer border-top': fixedHeaderFooter
    });
    if (!showModal) return null;
    return (
      <Modal
        enforceFocus={false}
        show={showModal}
        backdrop="static"
        dialogClassName={dialogClassName}
        backdropClassName="bs-backdrop"
        animation={false}
      >
        { !isEmpty(banner) &&
          <div data-testing-id="banner-wrapper" className={bannerOverrideClassName.length ? bannerOverrideClassName : bannerClassName}>
            <div className={bannerChildClass}>
              { banner.text }
            </div>
          </div>
        }
        <div className={titleClassName} style={{ paddingTop: '8px', paddingBottom: '8px' }}>
          {
            goBack &&
            <button data-testing-id="back-btn" className="btn btn-link remove-click-styling ico ico-md icon-back" onClick={goBack} />
          }
          {
            title &&
              <div className="margin-lg-left margin-lg-right">
                { title }
              </div>
          }
          {
            addCloseIcon &&
            <button className="btn btn-link remove-click-styling ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
          }
        </div>
        { header &&
          <Modal.Header bsClass={headerClassName}>
            {header}
            {subheader && <p className={subheaderClass}>{subheader}</p>}
          </Modal.Header>
        }
        <Modal.Body bsClass={bodyClassName}>
          { body }
        </Modal.Body>
        {
          footer &&
            <Modal.Footer bsClass={footerClassName}>
              {footer}
            </Modal.Footer>
        }
      </Modal>
    );
  }
}

BootstrapModal.propTypes = {
  banner: PropTypes.object,
  addCloseIcon: PropTypes.bool,
  header: PropTypes.object,
  footer: PropTypes.object,
  body: PropTypes.object,
  bannerClass: PropTypes.string,
  modalClass: PropTypes.string,
  bodyClass: PropTypes.string,
  footerClass: PropTypes.string,
  modalSize: PropTypes.string,
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  onClose: PropTypes.func,
  enforceFocus: PropTypes.bool,
  subheader: PropTypes.string,
  goBack: PropTypes.func,
  fixedHeaderFooter: PropTypes.bool,
  headerClass: PropTypes.string,
  subheaderClass: PropTypes.string,
  bannerOverrideClasses: PropTypes.string
};

export default BootstrapModal;
